import { LOCALES } from '@/core/i18n/constants/locales';
import { CultureIso } from '@/core/i18n/constants/culture-iso';

export const LOCALE_SETTINGS = {
    [LOCALES.Bulgarian]: {
        culture: 'bg',
        dateFormat: 'bg',
        cultureIso: CultureIso.Bulgarian
    },
    [LOCALES.Croatian]: {
        culture: 'hr',
        dateFormat: 'hr',
        cultureIso: CultureIso.Croatian
    },
    [LOCALES.Czech]: {
        culture: 'cs',
        dateFormat: 'cs',
        cultureIso: CultureIso.Czech
    },
    [LOCALES.Danish]: {
        culture: 'da',
        dateFormat: 'da',
        cultureIso: CultureIso.Danish
    },
    [LOCALES.Deutsch]: {
        culture: 'de',
        dateFormat: 'de',
        cultureIso: CultureIso.Deutsch
    },
    [LOCALES.Dutch]: {
        culture: 'nl',
        dateFormat: 'nl',
        cultureIso: CultureIso.Dutch
    },
    [LOCALES.English]: {
        culture: 'en',
        dateFormat: 'en-gb',
        cultureIso: CultureIso.English
    },
    [LOCALES.Finnish]: {
        culture: 'fi',
        dateFormat: 'fi',
        cultureIso: CultureIso.Finnish
    },
    [LOCALES.French]: {
        culture: 'fr',
        dateFormat: 'fr',
        cultureIso: CultureIso.French
    },
    [LOCALES.Greek]: {
        culture: 'el',
        dateFormat: 'el',
        cultureIso: CultureIso.Greek
    },
    [LOCALES.Hungarian]: {
        culture: 'hu',
        dateFormat: 'hu',
        cultureIso: CultureIso.Hungarian
    },
    [LOCALES.Italian]: {
        culture: 'it',
        dateFormat: 'it',
        cultureIso: CultureIso.Italian
    },
    [LOCALES.Norwegian]: {
        culture: 'nb',
        validator: 'nb_NO',
        dateFormat: 'nb',
        cultureIso: CultureIso.Norwegian
    },
    [LOCALES.Polish]: {
        culture: 'pl',
        dateFormat: 'pl',
        cultureIso: CultureIso.Polish
    },
    [LOCALES.Portuguese]: {
        culture: 'pt',
        validator: 'pt_PT',
        dateFormat: 'pt',
        cultureIso: CultureIso.Portuguese
    },
    [LOCALES.Romanian]: {
        culture: 'ro',
        dateFormat: 'ro',
        cultureIso: CultureIso.Romanian
    },
    [LOCALES.Spanish]: {
        culture: 'es',
        dateFormat: 'es',
        cultureIso: CultureIso.Spanish
    },
    [LOCALES.Swedish]: {
        culture: 'sv',
        dateFormat: 'sv',
        cultureIso: CultureIso.Swedish
    },
    [LOCALES.Slovenian]: {
        culture: 'sl',
        dateFormat: 'sl',
        validator: 'sl_SI',
        cultureIso: CultureIso.Slovenian
    },
    [LOCALES.Slovak]: {
        culture: 'sk',
        dateFormat: 'sk',
        validator: 'sk_SK',
        cultureIso: CultureIso.Slovak
    },
    [LOCALES.Latvian]: {
        culture: 'lv',
        dateFormat: 'lv',
        validator: 'lv_LV',
        cultureIso: CultureIso.Latvian
    },
    [LOCALES.Lithuanian]: {
        culture: 'lt',
        dateFormat: 'lt',
        validator: 'lt_LT',
        cultureIso: CultureIso.Lithuanian
    },
    [LOCALES.Estonian]: {
        culture: 'et',
        dateFormat: 'et',
        validator: 'et_EE',
        cultureIso: CultureIso.Estonian
    }
};
